<span class="label" title="Artikel (Klinik/alle)">Artikel (Klinik/alle)</span>

<div class="relevant-articles">
  <span class="relevant-articles__number">{{ relevantArticlesCount() | number }}</span>
  <span class="relevant-articles__separator">/</span>
  <span class="relevant-articles__total">{{ totalArticlesCount() | number }}</span>
</div>
